module.exports = __webpack_public_path__ + "img/happy.fd5c9287.png";